module.exports = __webpack_public_path__ + "img/enter-mac-key 4star.8ba79172.svg";